export const CAROUSEL_ITEM = 
 [
    {
      id: 1,
      altText: 'Slide 1',
      image: '/assets/images/bdr.png',
      caption: 'Slide 1',
      title: "Welcome to Abyssina Computer Training Center",
      sub_title:"The Best Computer Training Center in Bahir Dar"
    },
    {
      id: 2,
      altText: 'Slide 2',
      caption: 'Slide 2',
      image: '/assets/images/bdr.png',
      title: "More than 10 Years of Experience",
      sub_title:"Exprinaced Teachers and The Best Lab Enviroment"
    },
    {
      id: 3,
      altText: 'Slide 3',
      caption: 'Slide 3',
      image: '/assets/images/bdr.png',
      title: "Exceptional Education You Want",
      sub_title:"The Attention You Deserve"
    }
  ];